var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "blog" },
    [
      _c("image-simple", {
        attrs: {
          variant: "is-dark",
          "image-id": _vm.article.imageUrl,
          "mobile-image-id": _vm.article.imageUrl
        }
      }),
      _c(
        "div",
        [
          _c(
            "blog-header",
            [
              _c("template", { slot: "date" }, [
                _vm._v("\n        " + _vm._s(_vm.article.date) + "\n      ")
              ]),
              _c("template", { slot: "author" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.article.authorName) + "\n      "
                )
              ]),
              _c("template", { slot: "tags" }, [
                _vm._v("\n        " + _vm._s(_vm.article.tags) + "\n      ")
              ]),
              _c(
                "template",
                { slot: "social" },
                [
                  _c("social-share-bar", {
                    attrs: { article: _vm.article, variant: "mobile" }
                  })
                ],
                1
              )
            ],
            2
          ),
          _c("title-view", { attrs: { variant: "primary" } }, [
            _vm._v("\n      " + _vm._s(_vm.article.title) + "\n    ")
          ]),
          _c("div", { staticClass: "has-max-width" }, [
            _c(
              "div",
              { staticClass: "blog__content" },
              [
                _c("title-view", { attrs: { variant: "subtitle" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.article.smallTitle))])
                ]),
                _c("text-view", [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.article.text) }
                  }),
                  _c("br")
                ])
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "social-footer" },
            [_c("social-share-bar", { attrs: { article: _vm.article } })],
            1
          )
        ],
        1
      ),
      _c("footer-follow-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54bd8cec", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54bd8cec","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/blog/detail.vue
// module id = 570
// module chunks = 2